import image1 from './image-1.jpeg';
import image2 from './image-2.jpeg';
import image3 from './image-3.jpeg';
import image4 from './image-4.jpeg';

export const tableData = {
  columns: [
    { field: 'ASSET_ID', header: 'Asset ID', type: 'string' },
    { field: 'Asset_Type', header: 'Asset Type', type: 'string' },
    { field: 'System_Type', header: 'System Type', type: 'string' },
    { field: 'Material', header: 'Material', type: 'string' },
    { field: 'Diameter_mm', header: 'Diameter (mm)', type: 'string' },
    { field: 'Year_Laid', header: 'Year Laid', type: 'number' },
    { field: 'US_Node_ID', header: 'US Node ID', type: 'string' },
    { field: 'DS_Node_ID', header: 'DS Node ID', type: 'string' },
    { field: 'US_Invert_m', header: 'US Invert (m)', type: 'string' },
    { field: 'DS_Invert_m', header: 'DS Invert (m)', type: 'string' },
    { field: 'Length_m', header: 'Length (m)', type: 'string' },
    { field: 'Pipe_Type', header: 'Pipe Type', type: 'string' },
    { field: 'Status', header: 'Status', type: 'string' },
    { field: 'Owner', header: 'Owner', type: 'string' },
    { field: 'Current_Risk', header: 'Current Risk', type: 'string' },
    { field: 'Current_LOF', header: 'Current LOF', type: 'string' },
    { field: 'Current_COF', header: 'Current COF', type: 'string' },
    { field: 'Condition_Grade', header: 'Condition Grade', type: 'string' },
    { field: 'Location', header: 'Location', type: 'string' },
    { field: 'Street', header: 'Street', type: 'string' },
  ],
  rows: [
    {
      ASSET_ID: 'P-1001',
      Asset_Type: 'wwPipe',
      System_Type: 'SanitarySewer',
      Material: 'Concrete',
      Diameter_mm: '300',
      Year_Laid: 1985,
      US_Node_ID: 'MH-101',
      DS_Node_ID: 'MH-102',
      US_Invert_m: '45.2',
      DS_Invert_m: '44.8',
      Length_m: '120.5',
      Pipe_Type: 'Gravity Main',
      Status: 'Active',
      Owner: 'City Utilities',
      Current_Risk: '65.3',
      Current_LOF: '0.72',
      Current_COF: '0.91',
      Condition_Grade: '3',
      Location: 'Downtown',
      Street: 'Main Street',
    },
    {
      ASSET_ID: 'P-1002',
      Asset_Type: 'wwPipe',
      System_Type: 'SanitarySewer',
      Material: 'PVC',
      Diameter_mm: '200',
      Year_Laid: 2005,
      US_Node_ID: 'MH-102',
      DS_Node_ID: 'MH-103',
      US_Invert_m: '44.8',
      DS_Invert_m: '44.3',
      Length_m: '95.2',
      Pipe_Type: 'Gravity Main',
      Status: 'Active',
      Owner: 'City Utilities',
      Current_Risk: '32.1',
      Current_LOF: '0.45',
      Current_COF: '0.71',
      Condition_Grade: '2',
      Location: 'Downtown',
      Street: 'Oak Avenue',
    },
    {
      ASSET_ID: 'P-1003',
      Asset_Type: 'wwPipe',
      System_Type: 'CombinedSewer',
      Material: 'Cast Iron',
      Diameter_mm: '400',
      Year_Laid: 1972,
      US_Node_ID: 'MH-103',
      DS_Node_ID: 'MH-104',
      US_Invert_m: '44.3',
      DS_Invert_m: '43.9',
      Length_m: '150.8',
      Pipe_Type: 'Gravity Main',
      Status: 'Active',
      Owner: 'City Utilities',
      Current_Risk: '82.5',
      Current_LOF: '0.85',
      Current_COF: '0.97',
      Condition_Grade: '4',
      Location: 'Industrial',
      Street: 'Factory Road',
    },
    {
      ASSET_ID: 'P-1004',
      Asset_Type: 'wwPipe',
      System_Type: 'Stormwater',
      Material: 'HDPE',
      Diameter_mm: '250',
      Year_Laid: 2010,
      US_Node_ID: 'MH-104',
      DS_Node_ID: 'MH-105',
      US_Invert_m: '43.9',
      DS_Invert_m: '43.5',
      Length_m: '78.3',
      Pipe_Type: 'Gravity Main',
      Status: 'Active',
      Owner: 'City Utilities',
      Current_Risk: '28.4',
      Current_LOF: '0.38',
      Current_COF: '0.75',
      Condition_Grade: '2',
      Location: 'Residential',
      Street: 'Elm Street',
    },
    {
      ASSET_ID: 'P-1005',
      Asset_Type: 'wwPipe',
      System_Type: 'SanitarySewer',
      Material: 'Vitrified Clay',
      Diameter_mm: '225',
      Year_Laid: 1968,
      US_Node_ID: 'MH-105',
      DS_Node_ID: 'MH-106',
      US_Invert_m: '43.5',
      DS_Invert_m: '43.1',
      Length_m: '112.6',
      Pipe_Type: 'Gravity Main',
      Status: 'Inspection Required',
      Owner: 'City Utilities',
      Current_Risk: '71.8',
      Current_LOF: '0.78',
      Current_COF: '0.92',
      Condition_Grade: '3',
      Location: 'Residential',
      Street: 'Pine Avenue',
    },
    {
      ASSET_ID: 'P-1006',
      Asset_Type: 'wwPipe',
      System_Type: 'SanitarySewer',
      Material: 'PVC',
      Diameter_mm: '300',
      Year_Laid: 2015,
      US_Node_ID: 'MH-106',
      DS_Node_ID: 'MH-107',
      US_Invert_m: '43.1',
      DS_Invert_m: '42.7',
      Length_m: '88.9',
      Pipe_Type: 'Gravity Main',
      Status: 'Active',
      Owner: 'City Utilities',
      Current_Risk: '18.2',
      Current_LOF: '0.25',
      Current_COF: '0.73',
      Condition_Grade: '1',
      Location: 'Commercial',
      Street: 'Commerce Drive',
    },
    {
      ASSET_ID: 'P-1007',
      Asset_Type: 'wwPipe',
      System_Type: 'CombinedSewer',
      Material: 'Concrete',
      Diameter_mm: '500',
      Year_Laid: 1980,
      US_Node_ID: 'MH-107',
      DS_Node_ID: 'MH-108',
      US_Invert_m: '42.7',
      DS_Invert_m: '42.2',
      Length_m: '165.4',
      Pipe_Type: 'Gravity Main',
      Status: 'Active',
      Owner: 'Regional District',
      Current_Risk: '68.9',
      Current_LOF: '0.71',
      Current_COF: '0.97',
      Condition_Grade: '3',
      Location: 'Downtown',
      Street: 'Broadway',
    },
    {
      ASSET_ID: 'P-1008',
      Asset_Type: 'wwPipe',
      System_Type: 'Stormwater',
      Material: 'Concrete',
      Diameter_mm: '350',
      Year_Laid: 1995,
      US_Node_ID: 'MH-108',
      DS_Node_ID: 'MH-109',
      US_Invert_m: '42.2',
      DS_Invert_m: '41.8',
      Length_m: '102.1',
      Pipe_Type: 'Gravity Main',
      Status: 'Active',
      Owner: 'City Utilities',
      Current_Risk: '45.3',
      Current_LOF: '0.52',
      Current_COF: '0.87',
      Condition_Grade: '2',
      Location: 'Park District',
      Street: 'Park Boulevard',
    },
    {
      ASSET_ID: 'P-1009',
      Asset_Type: 'wwPipe',
      System_Type: 'SanitarySewer',
      Material: 'PVC',
      Diameter_mm: '150',
      Year_Laid: 2012,
      US_Node_ID: 'MH-109',
      DS_Node_ID: 'MH-110',
      US_Invert_m: '41.8',
      DS_Invert_m: '41.4',
      Length_m: '65.7',
      Pipe_Type: 'Gravity Main',
      Status: 'Active',
      Owner: 'City Utilities',
      Current_Risk: '22.6',
      Current_LOF: '0.31',
      Current_COF: '0.73',
      Condition_Grade: '1',
      Location: 'Residential',
      Street: 'Maple Lane',
    },
    {
      ASSET_ID: 'P-1010',
      Asset_Type: 'wwPipe',
      System_Type: 'SanitarySewer',
      Material: 'Concrete',
      Diameter_mm: '300',
      Year_Laid: 1975,
      US_Node_ID: 'MH-110',
      DS_Node_ID: 'MH-111',
      US_Invert_m: '41.4',
      DS_Invert_m: '41.0',
      Length_m: '125.3',
      Pipe_Type: 'Gravity Main',
      Status: 'Rehabilitation Planned',
      Owner: 'City Utilities',
      Current_Risk: '75.4',
      Current_LOF: '0.81',
      Current_COF: '0.93',
      Condition_Grade: '4',
      Location: 'Industrial',
      Street: 'Industrial Way',
    },
    {
      ASSET_ID: 'MH-101',
      Asset_Type: 'wwManhole',
      System_Type: 'SanitarySewer',
      Material: 'Brick',
      Diameter_mm: 'N/A',
      Year_Laid: 1985,
      US_Node_ID: 'N/A',
      DS_Node_ID: 'N/A',
      US_Invert_m: 'N/A',
      DS_Invert_m: 'N/A',
      Length_m: 'N/A',
      Pipe_Type: 'N/A',
      Status: 'Active',
      Owner: 'City Utilities',
      Current_Risk: '58.2',
      Current_LOF: '0.65',
      Current_COF: '0.89',
      Condition_Grade: '3',
      Location: 'Downtown',
      Street: 'Main Street',
    },
    {
      ASSET_ID: 'MH-102',
      Asset_Type: 'wwManhole',
      System_Type: 'SanitarySewer',
      Material: 'Precast Concrete',
      Diameter_mm: 'N/A',
      Year_Laid: 2005,
      US_Node_ID: 'N/A',
      DS_Node_ID: 'N/A',
      US_Invert_m: 'N/A',
      DS_Invert_m: 'N/A',
      Length_m: 'N/A',
      Pipe_Type: 'N/A',
      Status: 'Active',
      Owner: 'City Utilities',
      Current_Risk: '28.5',
      Current_LOF: '0.38',
      Current_COF: '0.75',
      Condition_Grade: '2',
      Location: 'Downtown',
      Street: 'Main Street',
    },
    {
      ASSET_ID: 'MH-103',
      Asset_Type: 'wwManhole',
      System_Type: 'CombinedSewer',
      Material: 'Cast In Place',
      Diameter_mm: 'N/A',
      Year_Laid: 1972,
      US_Node_ID: 'N/A',
      DS_Node_ID: 'N/A',
      US_Invert_m: 'N/A',
      DS_Invert_m: 'N/A',
      Length_m: 'N/A',
      Pipe_Type: 'N/A',
      Status: 'Active',
      Owner: 'City Utilities',
      Current_Risk: '72.1',
      Current_LOF: '0.76',
      Current_COF: '0.95',
      Condition_Grade: '3',
      Location: 'Industrial',
      Street: 'Factory Road',
    },
    {
      ASSET_ID: 'MH-104',
      Asset_Type: 'wwManhole',
      System_Type: 'Stormwater',
      Material: 'Precast Concrete',
      Diameter_mm: 'N/A',
      Year_Laid: 2010,
      US_Node_ID: 'N/A',
      DS_Node_ID: 'N/A',
      US_Invert_m: 'N/A',
      DS_Invert_m: 'N/A',
      Length_m: 'N/A',
      Pipe_Type: 'N/A',
      Status: 'Active',
      Owner: 'City Utilities',
      Current_Risk: '25.3',
      Current_LOF: '0.32',
      Current_COF: '0.79',
      Condition_Grade: '2',
      Location: 'Residential',
      Street: 'Elm Street',
    },
    {
      ASSET_ID: 'MH-105',
      Asset_Type: 'wwManhole',
      System_Type: 'SanitarySewer',
      Material: 'Brick',
      Diameter_mm: 'N/A',
      Year_Laid: 1968,
      US_Node_ID: 'N/A',
      DS_Node_ID: 'N/A',
      US_Invert_m: 'N/A',
      DS_Invert_m: 'N/A',
      Length_m: 'N/A',
      Pipe_Type: 'N/A',
      Status: 'Inspection Required',
      Owner: 'City Utilities',
      Current_Risk: '68.7',
      Current_LOF: '0.72',
      Current_COF: '0.95',
      Condition_Grade: '3',
      Location: 'Residential',
      Street: 'Pine Avenue',
    },
    {
      ASSET_ID: 'MH-106',
      Asset_Type: 'wwManhole',
      System_Type: 'SanitarySewer',
      Material: 'Precast Concrete',
      Diameter_mm: 'N/A',
      Year_Laid: 2015,
      US_Node_ID: 'N/A',
      DS_Node_ID: 'N/A',
      US_Invert_m: 'N/A',
      DS_Invert_m: 'N/A',
      Length_m: 'N/A',
      Pipe_Type: 'N/A',
      Status: 'Active',
      Owner: 'City Utilities',
      Current_Risk: '15.8',
      Current_LOF: '0.21',
      Current_COF: '0.75',
      Condition_Grade: '1',
      Location: 'Commercial',
      Street: 'Commerce Drive',
    },
    {
      ASSET_ID: 'MH-107',
      Asset_Type: 'wwManhole',
      System_Type: 'CombinedSewer',
      Material: 'Cast In Place',
      Diameter_mm: 'N/A',
      Year_Laid: 1980,
      US_Node_ID: 'N/A',
      DS_Node_ID: 'N/A',
      US_Invert_m: 'N/A',
      DS_Invert_m: 'N/A',
      Length_m: 'N/A',
      Pipe_Type: 'N/A',
      Status: 'Active',
      Owner: 'Regional District',
      Current_Risk: '65.2',
      Current_LOF: '0.68',
      Current_COF: '0.96',
      Condition_Grade: '3',
      Location: 'Downtown',
      Street: 'Broadway',
    },
    {
      ASSET_ID: 'MH-108',
      Asset_Type: 'wwManhole',
      System_Type: 'Stormwater',
      Material: 'Precast Concrete',
      Diameter_mm: 'N/A',
      Year_Laid: 1995,
      US_Node_ID: 'N/A',
      DS_Node_ID: 'N/A',
      US_Invert_m: 'N/A',
      DS_Invert_m: 'N/A',
      Length_m: 'N/A',
      Pipe_Type: 'N/A',
      Status: 'Active',
      Owner: 'City Utilities',
      Current_Risk: '38.9',
      Current_LOF: '0.45',
      Current_COF: '0.86',
      Condition_Grade: '2',
      Location: 'Park District',
      Street: 'Park Boulevard',
    },
    {
      ASSET_ID: 'MH-109',
      Asset_Type: 'wwManhole',
      System_Type: 'SanitarySewer',
      Material: 'Precast Concrete',
      Diameter_mm: 'N/A',
      Year_Laid: 2012,
      US_Node_ID: 'N/A',
      DS_Node_ID: 'N/A',
      US_Invert_m: 'N/A',
      DS_Invert_m: 'N/A',
      Length_m: 'N/A',
      Pipe_Type: 'N/A',
      Status: 'Active',
      Owner: 'City Utilities',
      Current_Risk: '19.4',
      Current_LOF: '0.26',
      Current_COF: '0.75',
      Condition_Grade: '1',
      Location: 'Residential',
      Street: 'Maple Lane',
    },
    {
      ASSET_ID: 'MH-110',
      Asset_Type: 'wwManhole',
      System_Type: 'SanitarySewer',
      Material: 'Brick',
      Diameter_mm: 'N/A',
      Year_Laid: 1975,
      US_Node_ID: 'N/A',
      DS_Node_ID: 'N/A',
      US_Invert_m: 'N/A',
      DS_Invert_m: 'N/A',
      Length_m: 'N/A',
      Pipe_Type: 'N/A',
      Status: 'Rehabilitation Planned',
      Owner: 'City Utilities',
      Current_Risk: '71.5',
      Current_LOF: '0.78',
      Current_COF: '0.92',
      Condition_Grade: '4',
      Location: 'Industrial',
      Street: 'Industrial Way',
    },
    {
      ASSET_ID: 'P-1011',
      Asset_Type: 'wwPipe',
      System_Type: 'WaterDistribution',
      Material: 'Ductile Iron',
      Diameter_mm: '150',
      Year_Laid: 2008,
      US_Node_ID: 'V-201',
      DS_Node_ID: 'V-202',
      US_Invert_m: 'N/A',
      DS_Invert_m: 'N/A',
      Length_m: '145.2',
      Pipe_Type: 'Pressurized Main',
      Status: 'Active',
      Owner: 'Water Authority',
      Current_Risk: '35.8',
      Current_LOF: '0.42',
      Current_COF: '0.85',
      Condition_Grade: '2',
      Location: 'Residential',
      Street: 'Cedar Street',
    },
    {
      ASSET_ID: 'P-1012',
      Asset_Type: 'wwPipe',
      System_Type: 'WaterDistribution',
      Material: 'PVC',
      Diameter_mm: '100',
      Year_Laid: 2018,
      US_Node_ID: 'V-202',
      DS_Node_ID: 'V-203',
      US_Invert_m: 'N/A',
      DS_Invert_m: 'N/A',
      Length_m: '92.7',
      Pipe_Type: 'Pressurized Main',
      Status: 'Active',
      Owner: 'Water Authority',
      Current_Risk: '12.3',
      Current_LOF: '0.18',
      Current_COF: '0.68',
      Condition_Grade: '1',
      Location: 'Residential',
      Street: 'Birch Avenue',
    },
    {
      ASSET_ID: 'P-1013',
      Asset_Type: 'wwPipe',
      System_Type: 'SanitarySewer',
      Material: 'Concrete',
      Diameter_mm: '350',
      Year_Laid: 1990,
      US_Node_ID: 'MH-111',
      DS_Node_ID: 'MH-112',
      US_Invert_m: '41.0',
      DS_Invert_m: '40.6',
      Length_m: '135.8',
      Pipe_Type: 'Gravity Main',
      Status: 'Active',
      Owner: 'City Utilities',
      Current_Risk: '52.7',
      Current_LOF: '0.58',
      Current_COF: '0.91',
      Condition_Grade: '2',
      Location: 'Commercial',
      Street: 'Market Street',
    },
    {
      ASSET_ID: 'P-1014',
      Asset_Type: 'wwPipe',
      System_Type: 'Stormwater',
      Material: 'HDPE',
      Diameter_mm: '300',
      Year_Laid: 2016,
      US_Node_ID: 'MH-112',
      DS_Node_ID: 'MH-113',
      US_Invert_m: '40.6',
      DS_Invert_m: '40.2',
      Length_m: '88.4',
      Pipe_Type: 'Gravity Main',
      Status: 'Active',
      Owner: 'City Utilities',
      Current_Risk: '21.5',
      Current_LOF: '0.28',
      Current_COF: '0.77',
      Condition_Grade: '1',
      Location: 'Park District',
      Street: 'Greenway',
    },
    {
      ASSET_ID: 'P-1015',
      Asset_Type: 'wwPipe',
      System_Type: 'SanitarySewer',
      Material: 'Vitrified Clay',
      Diameter_mm: '200',
      Year_Laid: 1965,
      US_Node_ID: 'MH-113',
      DS_Node_ID: 'MH-114',
      US_Invert_m: '40.2',
      DS_Invert_m: '39.8',
      Length_m: '118.9',
      Pipe_Type: 'Gravity Main',
      Status: 'Critical Condition',
      Owner: 'City Utilities',
      Current_Risk: '89.2',
      Current_LOF: '0.92',
      Current_COF: '0.97',
      Condition_Grade: '5',
      Location: 'Downtown',
      Street: 'Heritage Lane',
    },
    {
      ASSET_ID: 'P-1016',
      Asset_Type: 'wwPipe',
      System_Type: 'CombinedSewer',
      Material: 'Concrete',
      Diameter_mm: '450',
      Year_Laid: 1978,
      US_Node_ID: 'MH-114',
      DS_Node_ID: 'MH-115',
      US_Invert_m: '39.8',
      DS_Invert_m: '39.3',
      Length_m: '156.3',
      Pipe_Type: 'Gravity Main',
      Status: 'Inspection Required',
      Owner: 'City Utilities',
      Current_Risk: '73.6',
      Current_LOF: '0.79',
      Current_COF: '0.93',
      Condition_Grade: '3',
      Location: 'Industrial',
      Street: 'Warehouse Drive',
    },
    {
      ASSET_ID: 'P-1017',
      Asset_Type: 'wwPipe',
      System_Type: 'SanitarySewer',
      Material: 'PVC',
      Diameter_mm: '250',
      Year_Laid: 2013,
      US_Node_ID: 'MH-115',
      DS_Node_ID: 'MH-116',
      US_Invert_m: '39.3',
      DS_Invert_m: '38.9',
      Length_m: '97.5',
      Pipe_Type: 'Gravity Main',
      Status: 'Active',
      Owner: 'City Utilities',
      Current_Risk: '24.8',
      Current_LOF: '0.33',
      Current_COF: '0.75',
      Condition_Grade: '1',
      Location: 'Residential',
      Street: 'Willow Court',
    },
    {
      ASSET_ID: 'P-1018',
      Asset_Type: 'wwPipe',
      System_Type: 'Stormwater',
      Material: 'Concrete',
      Diameter_mm: '400',
      Year_Laid: 1988,
      US_Node_ID: 'MH-116',
      DS_Node_ID: 'MH-117',
      US_Invert_m: '38.9',
      DS_Invert_m: '38.5',
      Length_m: '142.6',
      Pipe_Type: 'Gravity Main',
      Status: 'Active',
      Owner: 'Regional District',
      Current_Risk: '48.3',
      Current_LOF: '0.54',
      Current_COF: '0.89',
      Condition_Grade: '2',
      Location: 'Commercial',
      Street: 'Shopping Plaza',
    },
    {
      ASSET_ID: 'P-1019',
      Asset_Type: 'wwPipe',
      System_Type: 'WaterTransmission',
      Material: 'Steel',
      Diameter_mm: '600',
      Year_Laid: 1995,
      US_Node_ID: 'V-203',
      DS_Node_ID: 'V-204',
      US_Invert_m: 'N/A',
      DS_Invert_m: 'N/A',
      Length_m: '1250.5',
      Pipe_Type: 'Pressurized Main',
      Status: 'Active',
      Owner: 'Water Authority',
      Current_Risk: '55.9',
      Current_LOF: '0.61',
      Current_COF: '0.92',
      Condition_Grade: '3',
      Location: 'Regional',
      Street: 'Highway 101',
    },
    {
      ASSET_ID: 'P-1020',
      Asset_Type: 'wwPipe',
      System_Type: 'SanitarySewer',
      Material: 'PVC',
      Diameter_mm: '175',
      Year_Laid: 2019,
      US_Node_ID: 'MH-117',
      DS_Node_ID: 'MH-118',
      US_Invert_m: '38.5',
      DS_Invert_m: '38.1',
      Length_m: '72.3',
      Pipe_Type: 'Gravity Main',
      Status: 'Active',
      Owner: 'City Utilities',
      Current_Risk: '16.7',
      Current_LOF: '0.22',
      Current_COF: '0.76',
      Condition_Grade: '1',
      Location: 'Residential',
      Street: 'Sunset Drive',
    },
  ],
};

export const imageData = [
  {
    id: '1',
    url: image1,
    description: 'Pipe Interior - Section 1',
  },
  {
    id: '2',
    url: image2,
    description: 'Pipe Interior - Section 2',
  },
  {
    id: '3',
    url: image3,
    description: 'Pipe Interior - Section 3',
  },
  {
    id: '4',
    url: image4,
    description: 'Pipe Interior - Section 4',
  },
];
